// Initial request, rendering, mapping data
import { Channel } from '@at/sauron-platform-core'
import { FacetGroupName } from '../../../__generated__/fed-graphql-types'
import { ChannelSearchTypeKey } from '../../channel-utilities'

export const facetsGroupsByChannel: Map<ChannelSearchTypeKey, FacetGroupName[]> = new Map()

facetsGroupsByChannel.set(Channel.cars, [
    FacetGroupName.acceleration,
    FacetGroupName.battery_range,
    FacetGroupName.body_type,
    FacetGroupName.boot_space,
    FacetGroupName.category_tag,
    FacetGroupName.charging_time,
    FacetGroupName.co2_emissions,
    FacetGroupName.colour,
    FacetGroupName.digital_retailing,
    FacetGroupName.distance,
    FacetGroupName.doors,
    FacetGroupName.drive_type,
    FacetGroupName.engine_power,
    FacetGroupName.engine_size,
    FacetGroupName.fuel_consumption,
    FacetGroupName.fuel_type,
    FacetGroupName.gearbox,
    FacetGroupName.insurance_group,
    FacetGroupName.keyword_search,
    FacetGroupName.lease_price_and_terms,
    FacetGroupName.make_and_model,
    FacetGroupName.mileage,
    FacetGroupName.monthly_price,
    FacetGroupName.previously_written_off,
    FacetGroupName.price,
    FacetGroupName.seats,
    FacetGroupName.seller_type,
    FacetGroupName.tax_per_year,
    FacetGroupName.year,
])

facetsGroupsByChannel.set(Channel.cycles, [
    FacetGroupName.keyword_search,
    FacetGroupName.make_and_model,
    FacetGroupName.price,
    FacetGroupName.frame_size,
    FacetGroupName.style,
    FacetGroupName.distance,
    FacetGroupName.colour,
    FacetGroupName.keyword_search,
])

facetsGroupsByChannel.set(Channel.vans, [
    FacetGroupName.distance,
    FacetGroupName.make_and_model,
    FacetGroupName.digital_retailing,
    FacetGroupName.price,
    FacetGroupName.monthly_price,
    FacetGroupName.vat_status,
    FacetGroupName.body_type,
    FacetGroupName.mileage,
    FacetGroupName.gearbox,
    FacetGroupName.fuel_type,
    FacetGroupName.year,
    FacetGroupName.colour,
    FacetGroupName.doors,
    FacetGroupName.seats,
    FacetGroupName.cab_type,
    FacetGroupName.wheelbase,
    FacetGroupName.engine_size,
    FacetGroupName.engine_power,
    FacetGroupName.fuel_consumption,
    FacetGroupName.co2_emissions,
    FacetGroupName.seller_type,
    FacetGroupName.previously_written_off,
    FacetGroupName.keyword_search,
])

facetsGroupsByChannel.set(Channel.bikes, [
    FacetGroupName.distance,
    FacetGroupName.make_and_model,
    FacetGroupName.engine_size_cc,
    FacetGroupName.engine_power,
    FacetGroupName.price,
    FacetGroupName.monthly_price,
    FacetGroupName.year,
    FacetGroupName.body_type,
    FacetGroupName.mileage,
    FacetGroupName.fuel_type,
    FacetGroupName.colour,
    FacetGroupName.seller_type,
    FacetGroupName.previously_written_off,
    FacetGroupName.keyword_search,
])
facetsGroupsByChannel.set(Channel.caravans, [
    FacetGroupName.distance,
    FacetGroupName.make_and_model,
    FacetGroupName.price,
    FacetGroupName.berth,
    FacetGroupName.year,
    FacetGroupName.style,
    FacetGroupName.trailer_axle_number,
    FacetGroupName.bedroom_layout,
    FacetGroupName.end_layout,
    FacetGroupName.mtplm,
    FacetGroupName.exterior_length,
    FacetGroupName.seller_type,
    FacetGroupName.keyword_search,
])

facetsGroupsByChannel.set(Channel.motorhomes, [
    FacetGroupName.distance,
    FacetGroupName.make_and_model,
    FacetGroupName.price,
    FacetGroupName.year,
    FacetGroupName.berth,
    FacetGroupName.gearbox,
    FacetGroupName.mileage,
    FacetGroupName.exterior_length,
    FacetGroupName.body_type,
    FacetGroupName.fuel_type,
    FacetGroupName.engine_size,
    FacetGroupName.seats_range,
    FacetGroupName.driver_position,
    FacetGroupName.end_layout,
    FacetGroupName.bedroom_layout,
    FacetGroupName.seller_type,
    FacetGroupName.previously_written_off,
    FacetGroupName.keyword_search,
])

facetsGroupsByChannel.set(Channel.trucks, [
    FacetGroupName.distance,
    FacetGroupName.make_and_model,
    FacetGroupName.style,
    FacetGroupName.body_type,
    FacetGroupName.year,
    FacetGroupName.price,
    FacetGroupName.axle_config,
    FacetGroupName.gross_vehicle_weight,
    FacetGroupName.engine_power,
    FacetGroupName.gearbox,
    FacetGroupName.fuel_type,
    FacetGroupName.emission_class,
    FacetGroupName.cab_type,
    FacetGroupName.mileage_km,
    FacetGroupName.driver_position,
    FacetGroupName.keyword_search,
])

facetsGroupsByChannel.set(Channel.farm, [
    FacetGroupName.distance,
    FacetGroupName.make_and_model,
    FacetGroupName.style,
    FacetGroupName.body_type,
    FacetGroupName.year,
    FacetGroupName.price,
    FacetGroupName.hours_used,
    FacetGroupName.keyword_search,
])

facetsGroupsByChannel.set(Channel.plant, [
    FacetGroupName.distance,
    FacetGroupName.make_and_model,
    FacetGroupName.style,
    FacetGroupName.body_type,
    FacetGroupName.year,
    FacetGroupName.price,
    FacetGroupName.hours_used,
    FacetGroupName.keyword_search,
])

facetsGroupsByChannel.set('cars-leasing', [
    FacetGroupName.battery_range,
    FacetGroupName.body_type,
    FacetGroupName.boot_space,
    FacetGroupName.charging_time,
    FacetGroupName.engine_size,
    FacetGroupName.fuel_type,
    FacetGroupName.gearbox,
    FacetGroupName.lease_price_and_terms,
    FacetGroupName.make_and_model,
    FacetGroupName.seats,
])

facetsGroupsByChannel.set('vans-leasing', [
    FacetGroupName.body_type,
    FacetGroupName.cab_type,
    FacetGroupName.engine_size,
    FacetGroupName.fuel_type,
    FacetGroupName.gearbox,
    FacetGroupName.lease_price_and_terms,
    FacetGroupName.make_and_model,
    FacetGroupName.seats,
    FacetGroupName.wheelbase,
])
